import { CommonModule } from '@angular/common'
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { Meta, Title } from '@angular/platform-browser'
import { Router, RouterModule } from '@angular/router'
import { SITE_TITLE } from '../../../shared/constants'

@Component({
  selector: 'app-bmi-calculator',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  templateUrl: './bmi-calculator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bmi-calculator.component.scss'
})
export class BmiCalculatorComponent {
  constructor(
    private meta: Meta,
    private title: Title,
    public http: HttpClient,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.bmiForm = this.fb.group({
      weight: ['', [Validators.required, Validators.min(1)]],
      height: ['', [Validators.required, Validators.min(1)]],
    })
  }

  public bmiForm: FormGroup

  bmiResultStr: string | null = null
  bmiResult: number | null = null


  ngOnInit() {
    this.title.setTitle(SITE_TITLE + " | BMI Calculator")
    this.meta.updateTag({ name: 'description', content: 'Calculate your Body Mass Index (BMI) with our free online BMI Calculator.' })
    this.meta.updateTag({ name: 'keywords', content: 'bmi, calculator, body mass index, calculate, tool, free' })

    this.calculateBMI()
  }

  onSubmit() {
    this.calculateBMI()
  }

  calculateBMI() {
    if (this.bmiForm.valid) {
      const weight = this.bmiForm.value.weight
      const height = this.bmiForm.value.height
      this.bmiResultStr = (weight / ((height / 100) ** 2)).toFixed(2)
      this.bmiResult = weight / ((height / 100) ** 2)
    }

    if (this.bmiResult !== null) {
      let description = ''
      let color = ''

      if (this.bmiResult < 18.5) {
        description = 'Underweight'
        color = 'blue'
      } else if (this.bmiResult >= 18.5 && this.bmiResult <= 24.9) {
        description = 'Optimum range'
        color = 'green'
      } else if (this.bmiResult >= 25 && this.bmiResult <= 29.9) {
        description = 'Overweight'
        color = 'yellow'
      } else if (this.bmiResult >= 30 && this.bmiResult <= 34.9) {
        description = 'Class I obesity'
        color = 'orange'
      } else if (this.bmiResult >= 35 && this.bmiResult <= 39.9) {
        description = 'Class II obesity'
        color = 'red'
      } else if (this.bmiResult >= 40) {
        description = 'Class III obesity'
        color = 'darkred'
      }

      // Display the result with description and color
      const resultElement = document.getElementById('bmiResult')
      if (resultElement) {
        resultElement.innerText = `BMI: ${this.bmiResult.toFixed(2)} - ${description}`
        resultElement.style.color = color
      }
    }
    // if (this.height > 0 && this.weight > 0) {
    //   const bmi = (this.weight / ((this.height / 100) ** 2)).toFixed(2)
    //   this.bmiValue = parseFloat(bmi)
    // }
  }
}
